<template>
  <p class="title">{{title}}</p>
</template>

<script>
export default {

  name: 'EpisodeTitle',

  data () {
    return {

    }
  },
  props: {
    title: String
  }
}
</script>

<style lang="css" scoped>
</style>
